import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './estilos.css';

createRoot(document.getElementById('raiz')).render(
  <React.StrictMode><App /></React.StrictMode>,
);
